import type { PropsWithChildren } from 'react';

import { QueryProvider } from './QueryProvider';
import { I18nProvider } from './I18nProvider';
import { ThemeProvider } from './ThemeProvider';
import { AuthProvider } from './AuthProvider';

export function AppProviders({ children }: PropsWithChildren<object>) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <I18nProvider>
          <AuthProvider>{children}</AuthProvider>
        </I18nProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
